import { getEmailAttachmentFileUrl } from '@/hooks/use-emails';
import { FileViewer } from '@/components/document-panel/file-viewer';
import { AttachmentLabelsBar } from '@/components/custom/attachment-labels-bar';

interface FileTabContentProps {
  attachmentId: string;
  fileName: string;
  transcript?: string;
  contentType?: string;
  labels: string[];
  classificationConfidence?: number | null;
  classificationMethod?: string | null;
  classificationReason?: string | null;
  disabled?: boolean;
}

export function FileTabContent({
  attachmentId,
  fileName,
  transcript,
  contentType,
  labels,
  classificationConfidence,
  classificationMethod,
  classificationReason,
  disabled,
}: FileTabContentProps): React.ReactElement {
  const fileUrl = getEmailAttachmentFileUrl(attachmentId);

  return (
    <div className="flex h-full min-h-0 flex-col">
      <AttachmentLabelsBar
        attachmentId={attachmentId}
        labels={labels}
        classificationConfidence={classificationConfidence}
        classificationMethod={classificationMethod}
        classificationReason={classificationReason}
        disabled={disabled}
      />
      <FileViewer
        fileUrl={fileUrl}
        fileName={fileName}
        withCredentials
        className="min-h-0 flex-1"
        transcript={transcript}
        contentType={contentType}
      />
    </div>
  );
}
